import React from 'react'
import Modal from 'react-bootstrap/Modal'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import Alert from 'react-bootstrap/Alert'

import Backend from "../../../utils/Backend"
import General from "../../../utils/General";

const getNormalizedAIQuery = (aiQuery = {}) => {
  const normalizedAIQuery = {
    name: '',
    prompt: '',
    list_ids: [],
    ...aiQuery,
  }
  normalizedAIQuery.list_ids = Array.isArray(normalizedAIQuery.list_ids) ? normalizedAIQuery.list_ids : []
  return normalizedAIQuery
}

export default class AIQuery extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      loading: false,
      error: null,
      show: props.show,
      type: props.type,
      lists: [],
      aiQuery: getNormalizedAIQuery(props.aiQuery),
    }
  }

  componentDidMount() {
    let {
      type
    } = this.state

    if(type !== "system_popular"){
      Backend.getLists(type).then(lists => {
        this.setState({lists})
      }).catch(e => General.showNotification(e.message, false))
    } else {
      Backend.getLists("system_popular").then(lists => {
        if(lists.length > 0){
          let aiQuery = this.state.aiQuery
          if(!aiQuery.list_ids || aiQuery.list_ids.length === 0){
            aiQuery.list_ids = [lists[0].id]
            this.setState({aiQuery})
          }
        }
      }).catch(e => General.showNotification(e.message, false))
    }
  }

  componentWillReceiveProps(nextProps){
    this.setState({
      show: nextProps.show,
      aiQuery: getNormalizedAIQuery(nextProps.aiQuery),
    })
  }

  _handleChange(e) {
    let aiQuery = this.state.aiQuery
    aiQuery[e.target.name] = e.target.value
    this.setState({ aiQuery, error: null })
  }

  _isFormValid(){
    let {
      name,
      prompt,
      list_ids
    } = this.state.aiQuery

    let error = null
    if(name == null || name.length === 0){
      error = "Please enter a valid name"
    }else if(prompt == null || prompt.length === 0){
      error = "Please enter a valid prompt"
    }else if(list_ids.length < 1 && this.state.type !== "system_popular"){
      error = "Please select a Collection"
    }

    if(error){
      General.showNotification(error, false)
      return false
    }
    return true
  }

  _handleSave(){
    let {
      aiQuery
    } = this.state

    if(!this._isFormValid()){
      return
    }

    this.setState({ loading: true })

    if(aiQuery.query_uuid){
      this._updateAIQuery(aiQuery)
    } else {
      this._addAIQuery(aiQuery)
    }
  }

  _addAIQuery(aiQuery){
    Backend.createAIQuery(aiQuery).then(result => {
      this.setState({ loading: false })
      General.showNotification("AI Query Added")
      this.props.onSaved(result)
    }).catch(error => {
      this.setState({ loading: false })
      General.showNotification(error.message, false)
    })
  }

  _updateAIQuery(aiQuery){
    Backend.updateAIQuery(aiQuery.query_uuid, aiQuery).then(result => {
      this.setState({ loading: false })
      General.showNotification("AI Query Updated")
      this.props.onSaved(result)
    }).catch(error => {
      this.setState({ loading: false })
      General.showNotification(error.message, false)
    })
  }

  render() {
    let {
      show,
      type,
      loading,
      aiQuery,
      lists,
      error
    } = this.state

    let isEdit = !!aiQuery.query_uuid
    let title = isEdit ? "Update AI Query" : "Add AI Query"
    let buttonTitle = isEdit ? "Update" : "Save"

    return (
      <Modal
        show={show}
        className="add-new-linkie"
        onHide={() => this.props.onHide()}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>

        <Modal.Body
          className='scroll-y mx-5 mx-xl-15 my-7'
        >

          { error &&
            <Alert variant={"danger"}>
              { error }
            </Alert>
          }

          <div className="d-flex flex-column mb-7 fv-row">
            <label className="d-flex align-items-center fs-6 fw-bold form-label mb-2">
              <span className="required">Query Name</span>
              <OverlayTrigger
                overlay={
                  <Tooltip >
                    Enter a name for the AI Query
                  </Tooltip>
                }
              >
                <i className="fas fa-exclamation-circle ms-2 fs-7" aria-label="Enter a name for the AI Query"></i>
              </OverlayTrigger>
            </label>
            <input
              type="text"
              name="name"
              className="form-control form-control-solid"
              placeholder="E.g. Daily World News Summary"
              value={ aiQuery.name }
              onChange={e => this._handleChange(e)}
            />
          </div>

          <div className="d-flex flex-column mb-7 fv-row">
            <label className="d-flex align-items-center fs-6 fw-bold form-label mb-2">
              <span className="required">AI Prompt</span>
              <OverlayTrigger
                overlay={
                  <Tooltip >
                    Enter the prompt that will be sent to the AI
                  </Tooltip>
                }
              >
                <i className="fas fa-exclamation-circle ms-2 fs-7" aria-label="Enter the AI prompt"></i>
              </OverlayTrigger>
            </label>
            <textarea
              name="prompt"
              className="form-control form-control-solid"
              placeholder="E.g. Give me a 5 bullet point summary of world news in the last 24 hours"
              rows={4}
              value={ aiQuery.prompt }
              onChange={e => this._handleChange(e)}
            />
          </div>

          {
            type !== "system_popular" &&
            <>
              <hr className="mb-7 dashed"/>

              <div className="d-flex flex-column mb-7 fv-row">
                <label className="fs-6 fw-bold form-label mb-2">
                  Collections<br/>
                  <small>Please choose which collections you want to add the AI Query to</small>
                </label>
                <div className="lists">
                  <div className="row">
                    <div className="col">
                      {
                        lists.map(list => (
                          <React.Fragment key={list.id}>
                            <input
                              type="checkbox"
                              className="btn-check"
                              id={`ai-list-${list.id}`}
                              autoComplete="off"
                              checked={aiQuery.list_ids?.includes(list.id)}
                              onChange={e => {
                                const listIds = aiQuery.list_ids || []
                                const hasList = listIds.includes(list.id)
                                const updatedListIds = hasList
                                  ? listIds.filter(id => id !== list.id)
                                  : [...listIds, list.id]
                                const updatedAiQuery = {...aiQuery, list_ids: updatedListIds}
                                this.setState({aiQuery: updatedAiQuery})
                              }}
                            />
                            <label className="btn btn-light-primary btn-sm" htmlFor={`ai-list-${list.id}`}>{list.name}</label>
                          </React.Fragment>
                        ))
                      }
                    </div>
                  </div>
                </div>
              </div>
            </>
          }

          <div className='text-center pt-15'>
            <div className='buttons-grid gg-7'>
              <button
                type="button"
                className="btn btn-light"
                onClick={() => this.props.onHide()}
              >
                Cancel
              </button>

              <button
                type="button"
                className="btn btn-primary"
                disabled={loading}
                onClick={() => this._handleSave()}
              >
                {buttonTitle}
              </button>
            </div>
          </div>

        </Modal.Body>

        
      </Modal>
    )
  }
}
